<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-section">
      <h3 class="footer-title">iFlyFinance</h3>
      <p class="footer-description">
        Streamline your insurance financing with our comprehensive platform.
      </p>
    </div>

    <div class="footer-section" *ngIf="!hideQuickLinks">
      <h4 class="footer-heading">Quick Links</h4>
      <ul class="footer-links">
        <li>
          <a routerLink="/home" class="footer-link">Home</a>
        </li>
        <li>
          <a routerLink="/login" class="footer-link">Login</a>
        </li>
        <li>
          <a routerLink="/signup" class="footer-link">Sign Up</a>
        </li>
      </ul>
    </div>

    <div class="footer-section">
      <h4 class="footer-heading">Legal</h4>
      <ul class="footer-links">
        <li>
          <a routerLink="/privacy-policy" class="footer-link">Privacy Policy</a>
        </li>
        <li>
          <a routerLink="/terms-of-use" class="footer-link">Terms of Use</a>
        </li>
      </ul>
    </div>

    <div class="footer-section">
      <h4 class="footer-heading">Contact</h4>
      <address class="footer-contact">
        <p>1881 California Ave, Suite 101</p>
        <p>Corona, CA 92881</p>
        <p>
          <a href="mailto:support@iflyfinance.com" class="footer-link">support&#64;iflyfinance.com</a>
        </p>
        <p>
          <a href="tel:18006664359" class="footer-link">800.666.4359</a>
        </p>
      </address>
    </div>
  </div>

  <div class="footer-bottom">
    <p class="footer-copyright">
      &copy; {{ currentYear }} iFlyFinance, Inc. All rights reserved.
    </p>
  </div>
</footer>
